<template>
  <div class="question-individual" :id="'pmlst-q-' + id">
    <div class="qi-wrapper">
      <div class="qi-text">{{ text }}</div>
      <div class="qi-options">
        <ul>
          <li
            v-for="(option, index) in options"
            :key="index"
            class="qi-options-option"
          >
            <button
              :class="buttonClasses(id, option.value)"
              @click.prevent="
                onQuestionSubmit({
                  id: id,
                  name: option.name,
                  value: option.value,
                  question: name
                })
              "
            >
              <font-awesome-icon v-if="option.icon" :i="option" />
              <span v-if="option.text">
                {{ option.text }}
              </span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@/components/FontAwesomeIcon'

export default {
  name: 'question',
  components: { FontAwesomeIcon },
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  computed: {
    id() {
      return this.$props.question.id
    },
    text() {
      return this.$props.question.text
    },
    options() {
      return this.$props.question.options
    },
    name() {
      return this.$props.question.name
    }
  },
  mounted() {
    this.$on('onQuestionSubmit', payload => {
      this.$store.dispatch('setQuestionResponse', payload)
    })
  },
  methods: {
    onQuestionSubmit(payload) {
      this.$emit('onQuestionSubmit', payload)
    },
    buttonClasses(id, value) {
      let outcome = ''
      let answer = this.$store.getters.getResponseForQuestion(id)
      if (value === answer) {
        outcome += ' response-active'
      }
      return 'response' + outcome
    }
  }
}
</script>
